<template>
  <div>
    <vs-card>
      <div class="mb-4">
        <h5>Availability</h5>
        <vs-button
          class="block"
          style="float: right"
          @click="handleAvailabilitysave"
          >Save</vs-button
        >
      </div>
      <div class="table-responsive">
        <table style="padding: 30px 0 120px" class="simple_border_table w-full">
          <thead>
            <tr>
              <td style="width: 100px">DAYS</td>
              <td style="width: 180px">START TIME</td>
              <td style="width: 180px">END TIME</td>
              <td>BREAKS</td>
              <td style="width: 150px">DURATION</td>
              <!-- <td style="width: 50px;"></td> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(eachData, index) in availabilityProps" :key="index" :class="[!eachData.is_active ? 'disable_tr' : '']" >
              <td>
                <div class="flex items-center">
                  <vs-switch v-model="eachData.is_active" />
                  <span class="inline-block px-4">{{ eachData.day }}</span>
                </div>
              </td>
              <td style="width: 150px">
                <div style="width: 150px" class="flatpickr_with_icon">
                  <flat-pickr
                    class="w-full"
                    v-model="eachData.available_from"
                    :config="startConfigdateTimePicker"
                  />
                  <vs-icon icon-pack="feather" icon="icon-clock" />
                </div>
              </td>
              <td style="width: 150px">
                <div style="width: 150px" class="flatpickr_with_icon">
                  <flat-pickr
                    class="w-full"
                    v-model="eachData.available_to"
                    :config="{
                      enableTime: true,
                      noCalendar: true,
                      dateFormat: 'H:i',
                      minTime: eachData.available_from,
                    }"
                  />
                  <vs-icon icon-pack="feather" icon="icon-clock" />
                </div>
              </td>
              <td class="relative">
                <div
                  class="add_break_holder"
                  :class="{ show: active_el == index }"
                >
                  <div class="flex justify-between">
                    <flat-pickr
                      v-model="setBreakStart"
                      class="w-full mx-2"
                      placeholder="Start Time"
                      :config="startConfigdateTimePicker"
                    />
                    <flat-pickr
                      v-model="setBreakEnd"
                      class="w-full mx-2"
                      placeholder="End Time"
                      :config="{
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: 'H:i',
                        minTime: setBreakStart,
                      }"
                    />
                  </div>
                  <vs-divider />
                  <div class="flex justify-center items-center mt-4">
                    <vs-button
                      type="border"
                      class="mx-2"
                      @click="closeBreak(index)"
                      >Close</vs-button
                    >
                    <vs-button class="mx-2" @click="addBreaks(index)"
                      >Save</vs-button
                    >
                  </div>
                </div>
                <div class="flex flex-wrap">
                  <div
                    v-for="(breakTime, indexBrk) in eachData.breaks"
                    :key="indexBrk"
                    class="m-1"
                  >
                    <div class="flatpickr_with_icon time_range_holder">
                      <div class="flatpickr_holder">
                        <flat-pickr
                          v-model="breakTime.break_from"
                          placeholder="Start Time"
                          :config="startConfigdateTimePicker"
                        />
                      </div>
                      <div class="flatpickr_holder">
                        <flat-pickr
                          v-model="breakTime.break_to"
                          placeholder="End Time"
                          :config="{
                            enableTime: true,
                            noCalendar: true,
                            dateFormat: 'H:i',
                            minTime: breakTime.break_from,
                          }"
                        />
                      </div>
                      <vs-icon icon-pack="feather" icon="icon-clock" />
                      <div
                        class="removeBreak"
                        @click="removeBreaks(index, indexBrk)"
                      >
                        <vs-icon icon-pack="feather" icon="icon-x" />
                      </div>
                    </div>
                  </div>
                  <span
                    style="cursor: pointer"
                    class="material-icons-outlined"
                    @click="showBreak(index)"
                    >add</span
                  >
                </div>
              </td>
              <td>
                {{
                  eachData.available_from.length > 5
                    ? eachData.available_from.slice(0, -3)
                    : eachData.available_from
                }}-{{
                  eachData.available_to.length > 5
                    ? eachData.available_to.slice(0, -3)
                    : eachData.available_to
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </vs-card>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import { TeacherUpdate } from '@/api/teacher'

export default {
  data () {
    return {
      addpopup: false,
      deletepopup: false,
      editpopup: false,
      customer_id: '',
      teacher_id: '',
      active_el: null,
      setBreakStart: null,
      setBreakEnd: null,
      startConfigdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i'
      }
    }
  },
  props: {
    availabilityProps: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  mounted () {
    this.customer_id = localStorage.getItem('customer_id')
    this.teacher_id = JSON.parse(localStorage.getItem('userInfo')).id
  },
  components: {
    flatPickr
  },
  methods: {
    async removeBreaks (index, indexBrk) {
      this.availabilityProps[index].breaks.splice(indexBrk, 1)
    },
    async handleAvailabilitysave () {
      try {
        const customer_id = localStorage.getItem('customer_id')

        const availabilty = this.availabilityProps.map((ele) => {
          return {
            ...ele,
            available_from:
              ele.available_from.length === 5
                ? `${ele.available_from}:00`
                : ele.available_from,
            available_to:
              ele.available_to.length === 5
                ? `${ele.available_to}:00`
                : ele.available_to,
            breaks:
              ele.breaks.length > 0
                ? ele.breaks.map((item) => {
                  return {
                    ...item,
                    break_from:
                        item.break_from.length === 5
                          ? `${item.break_from}:00`
                          : item.break_from,
                    break_to:
                        item.break_to.length === 5
                          ? `${item.break_to}:00`
                          : item.break_to
                  }
                })
                : ele.breaks
          }
        })
        const payload = {
          updateField: {
            availability: availabilty
          }
        }
        const { data } = await TeacherUpdate(
          payload,
          this.teacher_id,
          customer_id
        )
        console.log(data.data.operationalUser)
        this.$emit('setAfterUpdate', data)
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    },
    async addBreaks (index) {
      let afterBreak = true
      let existBreak = true

      const date = '2022-08-22 '

      const newBreakObj = {
        break_from: new Date(date + this.setBreakStart),
        break_to: new Date(date + this.setBreakEnd)
      }
      const existingBreakObj = {
        break_from: new Date(
          date + this.availabilityProps[index].available_from
        ),
        break_to: new Date(date + this.availabilityProps[index].available_to)
      }

      if (
        newBreakObj.break_from.getTime() <=
          existingBreakObj.break_from.getTime() ||
        existingBreakObj.break_to.getTime() <= newBreakObj.break_to.getTime()
      ) {
        afterBreak = false
      }
      this.availabilityProps[index].breaks.forEach((ele) => {
        const newBreakObj = {
          break_from: new Date(date + this.setBreakStart),
          break_to: new Date(date + this.setBreakEnd)
        }
        const existingBreakObj = {
          break_from: new Date(date + ele.break_from),
          break_to: new Date(date + ele.break_to)
        }
        if (
          (existingBreakObj.break_from.getTime() >=
            newBreakObj.break_from.getTime() &&
            newBreakObj.break_to.getTime() >=
              existingBreakObj.break_from.getTime()) ||
          (newBreakObj.break_from.getTime() >=
            existingBreakObj.break_from.getTime() &&
            existingBreakObj.break_to.getTime() >=
              newBreakObj.break_to.getTime()) ||
          (newBreakObj.break_from.getTime() <=
            existingBreakObj.break_to.getTime() &&
            newBreakObj.break_to.getTime() >=
              existingBreakObj.break_to.getTime())
        ) {
          existBreak = false
        }
      })
      if (existBreak && afterBreak) {
        this.availabilityProps[index].breaks.push({
          break_from: this.setBreakStart,
          break_to: this.setBreakEnd,
          id: null
        })
      } else if (!existBreak && afterBreak) {
        this.showSuccessMessage('Error', 'Duplicate breaks can not be added', 'danger')
      } else if (existBreak && !afterBreak) {
        this.showSuccessMessage('Error', 'Breaks can not be added before start time or after end time', 'danger')
      }

      this.active_el = null
      this.setBreakStart = null
      this.setBreakEnd = null
    },
    showBreak (id) {
      this.active_el = id
    },
    closeBreak () {
      this.active_el = null
    }
  }
}
</script>